module.exports = __webpack_public_path__ + "img/drink_pepsi.94287be6.png";